import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo/fullrein_logo.png'
import _imports_1 from '@/assets/profilePic/doctor.svg'


const _withScopeId = n => (_pushScopeId("data-v-06cefb3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "greeting-left" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-image",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_3 = { class: "doctor-name" }
const _hoisted_4 = { class: "greeting-right" }
const _hoisted_5 = { class: "tw-relative hover:tw-scale-105" }
const _hoisted_6 = {
  key: 0,
  class: "unread-messages-badge"
}
const _hoisted_7 = { class: "tw-text-white tw-font-[inter] tw-text-[10px] tw-font-[600]" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessagesIcon = _resolveComponent("MessagesIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_3, "Hello, " + _toDisplayString(_ctx.displayName), 1)
      ], 512), [
        [_vShow, _ctx.showUserName]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, { to: { name: 'Messages', hash: '#messages' } }, {
          default: _withCtx(() => [
            _createVNode(_component_MessagesIcon, { class: "tw-w-[37px]" })
          ]),
          _: 1
        }),
        (_ctx.totalUnreadMessages > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.totalUnreadMessages), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_8
    ])
  ]))
}